import axios from "axios";

const uri = "https://www.lefisc.com.br/api/apiDIFAL/calcular/verificaRegra";
const tok = "bd329d7b833e98162cffa558f9389759";

export default {
  getProdutosAcre(){
    return axios
      .get(`https://www.lefisc.com.br/api/apiDIFAL/calcular/acre/3/produtos/`)
      .then(res => {                
          return res.data;
      }, err => {
          throw new Error (console.error(err));
  });
},
  postFiltros(objeto) {
    //let objetoEnvia = JSON.stringify(objeto);

    return axios.post(`${uri}/${tok}`, objeto).then(
      res => {
        console.log("enviado com sucesso!");
        return res;
      },
      err => {
        throw new Error(console.error(err));
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/serviceFiltros.js